import { useState, useEffect } from 'react'
import store from '../store'
 
export const useAuthStatus = () => {
 
  const [loggedIn, setLoggedIn] = useState(false)
  const [checkingStatus, setCheckingStatus] = useState(true)
 
  const user = store.getState().userLogin
  const status = user.userDetails.status
 
  useEffect(() => {
    if (status === "ok") {
      setLoggedIn(true)
    } else {
      setLoggedIn(false)
    }
    setCheckingStatus(false)
  }, [status])

  return { loggedIn, checkingStatus }
 
}